// extracted by mini-css-extract-plugin
export default {"container":"navItem_container__6XhxH","navItem":"navItem_navItem__dhggb","active":"navItem_active__2mth2","activeDivider":"navItem_activeDivider__unoqq"};